import { useCallback } from "react";
import EventHandler from "views/logic/searchtypes/events/EventHandler";
import useUserDateTime from "hooks/useUserDateTime";
const useEvents = (config, events) => {
  const { formatTime } = useUserDateTime();
  const formatTimestamp = useCallback((timestamp) => formatTime(timestamp, "internal"), [formatTime]);
  return config.eventAnnotation && events ? EventHandler.toVisualizationData(events, formatTimestamp) : { eventChartData: void 0, shapes: void 0 };
};
export default useEvents;
